<section id="ai" class="relative overflow-hidden">
  <div class="ai-insights-stage relative">
    <div class="ai-insights-stage-fade absolute inset-0"></div>

    <div class="relative mx-auto max-w-page px-4 py-20 sm:px-6 sm:py-24 lg:px-8 lg:py-28">
      <div class="flex flex-col gap-12 sm:gap-16">
        <div class="flex max-w-3xl flex-col gap-5">
          <div class="flex flex-col gap-4">
            <p class="text-caption font-semibold uppercase tracking-[0.2em] text-slate-500">AI insights</p>

            <h2 class="text-h2 font-medium text-slate-950">
              Understand your data without building reports
            </h2>
          </div>

          <p class="max-w-2xl text-body1 leading-8 text-slate-600">
            Field teams capture plant condition, photos, geo coordinates, and notes on-site. FormOps
            structures every submission and builds the right view—maps, galleries, and condition
            trends—without manual reporting.
          </p>
        </div>

      <div class="grid gap-4 lg:grid-cols-[0.9fr_1.35fr_0.9fr] lg:gap-5">
        <!-- Plant condition score -->
        <div class="ai-insights-card flex min-h-[16rem] flex-col bg-white p-6 sm:p-7">
          <div class="flex flex-col gap-2">
            <p class="text-h6 font-medium text-black">Plant condition score</p>
            <p class="text-body2 text-slate-500">Median across all sites this week</p>
          </div>

          <div class="mt-auto flex items-end gap-2 pt-8">
            <span class="font-serif text-[3.5rem] leading-none text-warn-600">87</span>
            <span class="rounded-full bg-warn-100 px-2 py-0.5 text-body2 font-medium text-warn-700">
              +12
            </span>
          </div>
        </div>

        <!-- Field inspections -->
        <div class="ai-insights-card flex min-h-[16rem] flex-col gap-7 bg-white p-6 sm:p-7">
          <div class="flex flex-col gap-2">
            <p class="text-h6 font-medium text-black">Field inspections</p>
            <p class="text-body2 text-slate-500">North Valley plant circuit</p>
          </div>

          <div class="overflow-x-auto">
            <div class="min-w-[28rem]">
              <div class="grid grid-cols-[1.1fr_0.7fr_1.2fr_auto] gap-x-3 pb-3 text-caption text-slate-400 sm:gap-x-5">
                <span>Site</span>
                <span>Condition</span>
                <span>Captured</span>
              </div>

              <div class="divide-y divide-slate-100">
                @for (row of inspectionRows; track row.site) {
                  <div class="grid grid-cols-[1.1fr_0.7fr_1.2fr_auto] items-center gap-x-3 py-3.5 text-body2 text-slate-500 sm:gap-x-5">
                    <span class="font-medium text-slate-700">{{ row.site }}</span>
                    <span class="font-medium" [class]="conditionTextClass(row.condition)">
                      {{ row.conditionLabel }}
                    </span>
                    <span>{{ row.captured }}</span>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="grid grid-cols-4 gap-2">
            @for (photo of inspectionPhotos; track $index) {
              <img
                [src]="photo"
                alt="Field inspection photo"
                width="200"
                height="200"
                loading="lazy"
                decoding="async"
                class="aspect-square w-full rounded-lg object-cover" />
            }
          </div>
        </div>

        <!-- Inspections completed -->
        <div class="ai-insights-accent-card ai-insights-card flex min-h-[16rem] flex-col p-6 sm:p-7">
          <div class="flex flex-col gap-2">
            <p class="text-h6 font-medium text-white">Inspections completed</p>
            <p class="text-body2 text-success-200">Last 7 days · 4 plant sites</p>
          </div>

          <div class="mt-auto pt-8">
            <span class="font-serif text-[3.5rem] leading-none text-white">24</span>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</section>
